<template>
  <div
    class="flex justify-between items-center"
    :class="{ 'mb-4': hasMargin }"
  >
    <div>
      <div class="text-lg font-semibold">
        <Icon
          v-if="icon"
          :type="icon"
        />
        {{ title }}
      </div>
      <div
        v-if="subtitle"
        class="text-tertiary text-sm"
      >
        {{ subtitle }}
      </div>
    </div>
    <slot name="right"></slot>
  </div>
  <Separator
    v-if="hasSeparator"
    no-margin
  />
</template>

<script setup lang="ts">
import Icon from '@/components/icon/Icon.vue'
import Separator from '@/components/separator/Separator.vue'

defineProps({
  title: {
    type: String,
    default: null
  },
  subtitle: {
    type: String,
    default: null
  },
  icon: {
    type: String,
    default: null
  },
  hasMargin: {
    type: Boolean,
    default: true
  },
  hasSeparator: {
    type: Boolean,
    default: false
  }
})
</script>
